import fetch from './fetch';
import { localUrl } from '../services/url';

import { ENV } from '../settings/env';
import {
  SEND_APPOINTMENT_URL,
  FETCH_MOTIVES_URL,
  SEND_SHARE_URL,
  SEND_NEWSLETTER_URL
} from '../settings/popin';

export function sendAppointmentForm(form) {
  form.url = localUrl('', {pos: form.posId});

  return fetch(SEND_APPOINTMENT_URL[ENV], {
    method: "POST",
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(form)
  }).then(response => response.json());
}

export function getMotives() {
  return fetch(FETCH_MOTIVES_URL[ENV])
    .then(response => response.json());
}

export function sendShareForm(form) {
  form.url = localUrl('', {pos: form.posId});

  return fetch(SEND_SHARE_URL[ENV], {
    method: "POST",
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(form)
  }).then(response => response.json());
}

export function sendNewsletterForm(form) {
  return fetch(SEND_NEWSLETTER_URL[ENV], {
    method: "POST",
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    body: form
  }, 'cdc').then(response => response.json());
}



// WEBPACK FOOTER //
// ./src/services/popin.js